import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { TestFreeTest } from "./TestFreeTest";
import { Button } from "primereact/button";
import { translate } from "../localization/translateService";
import { getI18nLanguageFromLocalStorage } from "../helpers/localStorageHelper";

export default function PreTest() {
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isNeedConfirmModal, setIsNeedConfirmModal] = useState(true);

  const preTestRef = useRef(null);

  const [preTestTranslations, setPreTestTranslations] = useState({
    yesButtonLabel: "",
    noButtonLabel: "",
    preTestTitle: "",
    confirmHeaderTitle: "",
    confirmBodyTitle: "",
    congratsTitle: "",
  });

  const [preTestModalHeaderTitle, setPreTestModalHeaderTitle] = useState("");

  const handleOnCloseModal = () => {
    if (isNeedConfirmModal) {
      setConfirmModalOpen(true);
    }
    preTestRef.current?.triggerResetAnswer();
  };

  const handleOnCloseConfirmModal = () => {
    if (!confirmModalOpen) return;
    setConfirmModalOpen(false);
  };

  const handleConfirmAcceptButton = () => {
    setConfirmModalOpen(false);
    const currentLanguage = getI18nLanguageFromLocalStorage();
    window.location.href = `/${currentLanguage}`;
  };

  const handleSetIsNeedConfirmModal = (value) => {
    setIsNeedConfirmModal(value);
    if (!value) {
      setPreTestModalHeaderTitle(preTestTranslations.congratsTitle);
    }
  };

  useEffect(() => {
    const loadTranslations = async () => {
      const preTestTitle = await translate("UMBRACO_LANDING.FREE_TEST.TITLE.PRE_TEST");
      const confirmHeaderTitle = await translate("UMBRACO_LANDING.FREE_TEST.TITLE.CONFIRM_HEADER_TITLE");
      const yesButtonLabel = await translate("UMBRACO_LANDING.FREE_TEST.BUTTON.YES");
      const noButtonLabel = await translate("UMBRACO_LANDING.FREE_TEST.BUTTON.NO");
      const confirmBodyTitle = await translate("UMBRACO_LANDING.FREE_TEST.TITLE.CONFIRM_BODY");
      const congratsTitle = await translate("UMBRACO_LANDING.FREE_TEST.TITLE.CONGRATS");

      setPreTestTranslations({
        yesButtonLabel,
        noButtonLabel,
        preTestTitle,
        confirmHeaderTitle,
        confirmBodyTitle,
        congratsTitle,
      });

      setPreTestModalHeaderTitle(preTestTitle);
    };

    loadTranslations();
  }, []);

  useEffect(() => {
    window.onpageshow = function (event) {
      if (event.persisted) {
        document.location.reload();
      }
    };
  }, []);

  return (
    <div className="pre-test-wrapper">
      <h4 className="keduall-typography heading-h4-semibold-600 text-center mb-3">{preTestModalHeaderTitle}</h4>
      <TestFreeTest ref={preTestRef} handleForceCloseModal={() => {}} handleCloseModal={handleOnCloseModal} setIsNeedConfirmModal={handleSetIsNeedConfirmModal} />
      <Dialog
        draggable={false}
        visible={confirmModalOpen}
        className=" kedual-dialog-free-test keduall-dialog pre-test-modal pre-test-modal-confirm"
        onHide={handleOnCloseConfirmModal}
        header={preTestTranslations?.confirmHeaderTitle}
      >
        {/* New design (Figma 2453:3817): no illustration; "Yes, leave" (outline) +
            "Continue test" (blue). Copy comes from the translation keys below. */}
        <div className="flex flex-column gap-40 justify-content-between align-items-center">
          <h3 className="keduall-typography heading-h4-normal-400 text-third-txt-color max-width-512 text-center">{preTestTranslations?.confirmBodyTitle}</h3>
          <div className="flex flex-wrap justify-content-center gap-3">
            <Button className="keduall-buttons button-outlined-default-large-secondary" onClick={handleConfirmAcceptButton}>
              <h6 className="keduall-typography heading-h6-semibold-600">{preTestTranslations?.yesButtonLabel}</h6>
            </Button>
            <Button className="keduall-buttons button-filled-default-large-primary" onClick={() => setConfirmModalOpen(false)}>
              <h6 className="keduall-typography heading-h6-semibold-600">{preTestTranslations?.noButtonLabel}</h6>
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
